import { Selection } from 'types'
import { camelCase, mapKeys } from 'lodash'
import { makeAutoObservable } from 'mobx'

export interface RequestJson {
  id: number
  selection: Selection | null
  prompt: { [key: string]: any }
  article_id: string
  layer_id: string
}

export class GenerateSuggestionRequest {
  id: number
  articleId: string
  layerId: string
  selection?: Selection | null
  prompt: { [key: string]: any }

  constructor(json: RequestJson) {
    this.id = json.id
    this.selection = json.selection
    this.articleId = json.article_id
    this.layerId = json.layer_id
    this.prompt = mapKeys(json.prompt, (_, k) => camelCase(k))
    makeAutoObservable(this)
  }
}
